import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import barListApi from "api/barListApi";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import { useRole } from "components/Hooks/UserHooks";
import {
  COLOR_BAR_LIST_OPEN_STATUS,
  COLOR_BAR_LIST_PARTNER_STATUS,
  COLOR_BAR_LIST_PLAN,
  LIST_OPTION_BAR_LIST_OPEN_STATUS,
  LIST_OPTION_BAR_LIST_PARTNER_STATUS,
  LIST_OPTION_BAR_LIST_PLAN,
  LIST_OPTION_BAR_LIST_RATING,
  LIST_OPTION_BAR_LIST_TYPE,
} from "helpers/constans";
import CountUp from "react-countup";
import { getBarList } from "store/bar-list/thunk";
import { formatDateStringToKorea, formatNumberWithCommas } from "helpers/format";
import TooltipCustom from "components/Common/TooltipCustom";
import { Link } from "react-router-dom";
import CollapseFilter from "components/Common/CollapseFilter";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import BarListDetail from "./BarListDetail";
import ModalPreview from "components/Common/ModalPreview";
import BarForm from "./BarForm";
import DropdownOptionStar from "components/Common/DropdownOptionStar";
import DropdownAsyncBarType from "components/Common/DropdownAsyncBarType";
import noImage1 from "../../assets/images/no-image.jpg";
import imgEmptyStore from "../../assets/images/empty_store.png";
import CopyWrapper from "components/Common/CopyWrapper";
import { QRCodeCanvas } from "qrcode.react";
import { truncate } from "utils";
import ModalPreviewQRCode from "components/Common/ModalPreviewQRCode";

interface Option {
  label: string;
  value: string;
}

const TYPE_SELECT_DEFAULT: string = "created_at";
registerLocale("en", en);
registerLocale("ko", ko);

const BarList = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    keyword: withDefault(StringParam, ""),
    type: withDefault(StringParam, ""),
    rating: withDefault(StringParam, ""),
    plan: withDefault(StringParam, ""),
    status: withDefault(StringParam, ""),
    partner_status: withDefault(StringParam, ""),
    sort_by: withDefault(StringParam, "created_at"),
    order_by: withDefault(StringParam, "DESC"),
  });

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [linkImage, setLinkImage] = useState<any>(null);
  const [itemToDetail, setItemToDetail] = useState<any>(null);
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [isShowDetail, setIsShowDetail] = useState<boolean>(false);
  const [previewQRCode, setPreviewQRCode] = useState<any>(null);
  const [tabDetailActive, setTabDetailActive] = useState<any>('');

  const [optionBarTypeSearch, setOptionBarTypeSearch] = useState<any | null>({
    label: t("All Filter"),
    value: "all",
  });

  const [keywordSearch, setKeywordSearch] = useState<string>(
    query?.keyword || ""
  );

  const [typeSearch, setTypeSearch] = useState<Option | any>(
    LIST_OPTION_BAR_LIST_TYPE?.find(
      (item) => String(item?.value) === String(query?.type)
    )?.value || ""
  );

  const [ratingSearch, setRatingSearch] = useState<Option | any>(
    LIST_OPTION_BAR_LIST_RATING?.find((item) => item?.value == query?.rating)
      ?.value || ""
  );

  const [planSearch, setPlanSearch] = useState<Option | any>(
    LIST_OPTION_BAR_LIST_PLAN?.find(
      (item) => String(item?.value) === String(query?.plan)
    )?.value || ""
  );

  const [statusSearch, setStatusSearch] = useState<Option | any>(
    LIST_OPTION_BAR_LIST_OPEN_STATUS?.find(
      (item) => item?.value === query?.status
    )?.value || ""
  );

  const [partnerStatusSearch, setPartnerStatusSearch] = useState<Option | any>(
    LIST_OPTION_BAR_LIST_PARTNER_STATUS?.find(
      (item) => item?.value == query?.partner_status
    )?.value || ""
  );

  const LIST_OPTION_BAR_DETAIL_REVIEW_STAR_RATING_LANG = [1, 2, 3, 4, 5]?.map(
    (item: any) => ({
      value: item,
      label: item,
    })
  );

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.BarList;
  const AdvertisementProperties = createSelector(
    selectLayoutState,
    (state) => ({
      bars: state.bars,
      isBarLoading: state.isBarLoading,
      isBarSuccess: state.isBarSuccess,
      error: state.error,
    })
  );

  // Inside your component
  const { bars, isBarLoading } = useSelector(AdvertisementProperties);

  function loadTableData() {
    dispatch(getBarList(query));
  }

  const searchData = () => {
    setQuery({
      ...query,
      keyword: encodeURIComponent(keywordSearch),
      type: typeSearch === "all" ? "" : typeSearch,
      rating: ratingSearch,
      plan: planSearch,
      status: statusSearch,
      partner_status: partnerStatusSearch,
      sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        keyword: "",
        type: "",
        rating: "",
        plan: "",
        status: "",
        partner_status: "",
        sort_by: TYPE_SELECT_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );

    setKeywordSearch((_prev) => "");
    setTypeSearch((_prev: any) => "");
    setRatingSearch((_prev: any) => "");
    setPlanSearch((_prev: any) => "");
    setStatusSearch((_prev: any) => "");
    setPartnerStatusSearch((_prev: any) => "");
    setOptionBarTypeSearch({
      label: t("All Filter"),
      value: "all",
    });
  };

  // Begin::Change status
  const [isLoadingUpdate, setIsLoadingUpdate] = useState<boolean>(false);

  const handleOnConfirmUpdate = async (item: {
    id: number | string;
    is_active: string | boolean;
  }) => {
    try {
      if (!item) {
        return;
      }
      setIsLoadingUpdate((_prev) => true);
      const response: any = await barListApi.updateBar(item?.id, {
        is_active: item?.is_active,
      });
      setIsLoadingUpdate((_prev) => false);
      if (response?.code === 200) {
        dispatch(getBarList(query));
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoadingUpdate((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };
  // End::Change status

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        thClass: "align-middle",
        Cell: ({ ...props }) => {
          const item = props?.row?.original;
          return (
            <CopyWrapper contentCopy={item?.id || ''} style={{ display: 'inline-flex', minWidth: '60px' }}>
              <div>
                {bars?.meta?.total -
                  ((query?.page - 1) * query?.limit + props?.row?.index)}
              </div>
            </CopyWrapper>
          );
        },
      },
      {
        Header: t("Activity"),
        accessor: "is_active",
        thWidth: 140,
        thClass: "align-middle text-center  whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div
              className="form-check form-switch form-switch-sm text-center"
              dir="ltr"
            >
              <input
                type="checkbox"
                className="form-check-input"
                name="is_active"
                checked={!!cell?.value}
                onChange={(e) => {
                  const value = e?.target?.checked;
                  handleOnConfirmUpdate({ id: item?.id, is_active: !!value });
                }}
              />
            </div>
          );
        },
      },
      {
        Header: t("Thumbnail"),
        accessor: "files",
        thClass: "align-middle text-center",
        filterable: true,
        sortable: false,
        thWidth: 170,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          let thumbnailUrl = item?.thumbnail_url;
          if (!thumbnailUrl) {
            const isVideo =
              item?.files?.[0]?.url && item?.files?.[0]?.type === "video";
            thumbnailUrl = isVideo
              ? item?.files?.[0]?.preview
              : item?.files?.[0]?.url;
          }

          return (
            <>
              <div className="w-100 text-center " style={{ minWidth: "150px" }}>
                <div
                  style={{ width: "90px" }}
                  className="m-auto cursor-pointer"
                  onClick={() => {
                    if(!thumbnailUrl) return;

                    let linkImage = item?.thumbnail_url
                      ? { url: item?.thumbnail_url }
                      : { urls: item?.files };
                    setLinkImage(linkImage);
                    document.body.className = "modal-open_img";
                  }}
                >
                  <img
                    src={thumbnailUrl ?? imgEmptyStore}
                    className="flex-shrink-0 rounded w-100"
                    alt="thumbnail"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = imgEmptyStore;
                    }}
                  />
                </div>
              </div>
            </>
          );
        },
      },
      {
        Header: t("Store Name"),
        accessor: "title",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return cell?.value ? (
            <>
              <div className="cursor-pointer hover-underline" style={{ minWidth: "180px" }} onClick={(e) => {
                e.preventDefault();
                setItemToDetail(item);
                setIsShowDetail(false);
                setTabDetailActive(null);
              }} >
                {cell?.value}
              </div>
            </>
          ) : '-';
        },
      },
      {
        Header: t("Location"),
        accessor: "short_address",
        filterable: true,
        sortable: false,
        thClass: "align-middle text-center whitespace-nowrap",
        thWidth: 150,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const lat = item?.lat;
          const lng = item?.long;
          // const url = "https://www.google.com/maps/search/${lat},${lng}/@${lat},${lng},17z?entry=ttu"
          return (
            (lat || lng) ? (
              <div
                className="cursor-pointer text-center"
                style={{ minWidth: "100px" }}
              >
                <a
                  href={`https://www.google.com/maps/search/${lat},${lng}/@${lat},${lng},17z?entry=ttu`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {cell?.value}
                </a>
              </div>
            ) : <div className="text-center">-</div>
          );
        },
      },
      {
        Header: t("Phone Number"),
        accessor: "phone",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            <>
              <div className="cursor-pointer" style={{ minWidth: "180px" }}>
                {cell?.value ?? '-'}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Store Type"),
        accessor: "type",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 100,
        Cell: (cell: any) => {
          return (
            <>
              <div className="cursor-pointer" style={{ minWidth: "100px" }}>
                {(i18n?.language === "ko" ? cell?.value?.ko : cell?.value?.en) ?? '-'}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Plan"),
        accessor: "plan",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "align-middle text-center",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_BAR_LIST_PLAN[status] || "secondary"}`}
              >
                {t(
                  LIST_OPTION_BAR_LIST_PLAN?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },

      {
        Header: t("Partner Status"),
        accessor: "partner_status",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "align-middle text-center",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_BAR_LIST_PARTNER_STATUS[status] || "secondary"
                  }`}
              >
                {t(
                  LIST_OPTION_BAR_LIST_PARTNER_STATUS?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Rating"),
        accessor: "review_point",
        filterable: true,
        sortable: true,
        thClass: "align-middle text-end whitespace-nowrap",
        thWidth: 100,
        Cell: (cell: any) => {
          return (
            <>
              <div
                className="cursor-pointer text-center"
                style={{ minWidth: "70px" }}
              >
                {cell?.value ? cell?.value?.toFixed(1) : 0}
              </div>
            </>
          );
        },
      },
      {
        Header: "",
        accessor: "__",
        filterable: false,
        sortable: false,
        thWidth: 30,
        thClass: "align-middle text-end",
        Cell: (cell: any) => {
          return (
            <>

            </>
          );
        },
      },
      {
        Header: t('Views'),
        accessor: "pv",
        thClass: 'align-middle text-end',
        filterable: false,
        sortable: false,
        thWidth: 240,
        thComponent: () => (
          <table>
            <thead>
              <tr>
                <th className="text-center pb-1 none-sticky" colSpan={2}>
                  {t('Views')}
                </th>
              </tr>
              <tr>
                <tr>
                  <th className="text-center px-0 py-1 cursor-pointer none-sticky" style={{ width: '120px' }}
                  >
                    {t('PV')}
                  </th>
                  <th className="text-center px-0 py-1 cursor-pointer none-sticky" style={{ width: '120px' }}
                  >
                    {t('UV')}
                  </th>
                </tr>
              </tr>
            </thead>
          </table>
        ),
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div className="d-flex text-center">
              <div style={{ width: '120px' }}>{formatNumberWithCommas(item?.pv)}</div>
              <div style={{ width: '120px', borderLeft: "1px solid #eaeaea" }}>{formatNumberWithCommas(item?.uv)}</div>
            </div>
          );
        },
      },
      {
        Header: t("Likes"),
        accessor: "like_count",
        filterable: false,
        sortable: true,
        thClass: "align-middle text-end whitespace-nowrap",
        thWidth: 100,
        Cell: (cell: any) => {
          return (
            <>
              <div
                className="cursor-pointer text-end pe-3"
                style={{ minWidth: "70px" }}
              >
                {formatNumberWithCommas(cell?.value)}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Connection"),
        accessor: "connection_count",
        filterable: false,
        sortable: false,
        thClass: "align-middle text-end whitespace-nowrap",
        thWidth: 100,
        Cell: (cell: any) => {
          return (
            <>
              <div
                className="cursor-pointer text-end"
                style={{ minWidth: "70px" }}
              >
                {formatNumberWithCommas(cell?.value)}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Reviews"),
        accessor: "comment_count",
        filterable: true,
        sortable: true,
        thClass: "align-middle text-end whitespace-nowrap",
        thWidth: 100,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;

          return (
            <>
              <div
                className="cursor-pointer text-end text-primary pe-3"
                style={{ minWidth: "70px" }}
                onClick={() => {
                  setItemToDetail(item);
                  setTabDetailActive('Rating & Review');
                }}
              >
                {formatNumberWithCommas(cell?.value)}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Hash Tag"),
        accessor: "hashtag",
        filterable: false,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-start",
        thWidth: 150,
        Cell: (cell: any) => {
          const allKeyword = cell?.value;
          let shortKeyword = [];

          if (allKeyword?.length > 2) {
            shortKeyword = [...allKeyword].splice(0, 2);
          } else {
            shortKeyword = allKeyword;
          }

          const [isShowMore, setIsShowMore] = useState(false);

          const showData = isShowMore ? allKeyword : shortKeyword;

          return (
            allKeyword?.length > 0 ? (
              <div className="d-flex flex-column gap-1">
                {showData?.map((item: any, index: number) => {
                  let tagName: string = "";

                  tagName += `${item ? `<span class='tag-style'>${item} </span>` : ""
                    }`;

                  return (
                    <div
                      style={{ minWidth: "150px" }}
                      dangerouslySetInnerHTML={{ __html: tagName }}
                      key={index}
                    />
                  );
                })}

                {allKeyword?.length > 2 && (
                  <span
                    onClick={(e) => {
                      e.preventDefault();
                      setIsShowMore((prev) => !prev);
                    }}
                    style={{
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                    className="link-primary fs-12 d-inline"
                  >
                    <span>{isShowMore ? t("View Less") : t("View More")}</span>
                    <i
                      className={`${isShowMore
                        ? "ri-arrow-up-s-line"
                        : "ri-arrow-down-s-line"
                        } fs-16 position-relative`}
                      style={{ top: "4px" }}
                    ></i>
                  </span>
                )}
              </div>
            ) : '-'
          );
        },
      },
      {
        Header: t("Baive Link"),
        accessor: "user_branch_link",
        thClass: "align-middle whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 360,
        Cell: (cell: any) => {
          const branch_link = cell?.value;

          return (
            branch_link && (
              <div className="d-flex gap-3 align-items-center text-primary" style={{ maxWidth: "350px" }}>
                <div
                  className="cursor-pointer"
                  onClick={() => setPreviewQRCode(branch_link)}
                >
                  <QRCodeCanvas value={branch_link} size={60} />
                </div>
                <CopyWrapper
                  contentCopy={branch_link}
                  style={{ minWidth: "70px" }}
                >
                  <Link to={branch_link} target="_blank" className="hover-underline">  {truncate(branch_link, 70)}</Link>
                </CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("Baive Manager Link"),
        accessor: "manager_branch_link",
        thClass: "align-middle whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 420,
        Cell: (cell: any) => {
          const branch_link: any = cell?.row?.original?.manager_branch_link;

          return (
            branch_link && (
              <div className="d-flex gap-3 align-items-center text-primary" style={{ maxWidth: "420px" }}>
                <div
                  className="cursor-pointer"
                  onClick={() => setPreviewQRCode(branch_link)}
                >
                  <QRCodeCanvas value={branch_link} size={60} />
                </div>
                <CopyWrapper
                  contentCopy={branch_link}
                  style={{ minWidth: "70px" }}
                >
                  <Link to={branch_link} target="_blank" className="hover-underline">  {truncate(branch_link, 70)}</Link>
                </CopyWrapper>
              </div>
            )
          );
        },
      },

      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "align-middle text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Updated at"),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "align-middle text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Button Action"),
        thClass: "align-middle text-center",
        thWidth: 120,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0 "
              style={{ justifyContent: "center" }}
            >
              {/* <TooltipCustom
                title={t("View Detail")}
                id={`view-md-${item?.id}`}
              >
                <li className="list-inline-item" id={`view-md-${item?.id}`}>
                  <Link
                    className="btn btn-sm btn-soft-primary edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setItemToDetail(item);
                      setIsShowDetail(true);
                    }}
                  >
                    <i className="ri-eye-fill align-bottom "></i>
                  </Link>
                </li>
              </TooltipCustom> */}

              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToDetail(item);
                    setIsShowDetail(false);
                    setTabDetailActive(null);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom "></i>
                </Link>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-danger edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToDelete(item);
                  }}
                >
                  <i className="ri-delete-bin-3-fill align-bottom"></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    [i18n?.language, bars?.meta?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
  }, []);

  const onCloseQRCodeClick = () => {
    setPreviewQRCode(null);
  };

  // Begin::Delete
  const handleActionDelete = async (id: any) => {
    if (!id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await barListApi?.deleteBar(id);
      if (response?.data) {
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        setItemToDelete(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen((_prev) => false);
  };

  const triggerRefresh = () => {
    onCloseClick();
    loadTableData();
  };

  const handleCloseModal = () => {
    setItemToDetail(null);

    if (!isShowDetail) {
      loadTableData();
    }
  };

  useEffect(() => {
    loadTableData();
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    document.title = `${t("Store")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={t("Store")}
            pageTitle={t("Home")}
          />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={bars?.meta?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                    <div className="col-sm-auto text-end">
                      <button
                        type="button"
                        className="btn btn-success d-md-block"
                        onClick={() => {
                          setIsOpen(true);
                          setItemToEdit(null);
                        }}
                      >
                        <i className="ri-add-fill align-bottom me-1"></i>{" "}
                        {t("Button Create Store")}
                      </button>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Keyword")}
                          isShow={!!keywordSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Keyword")}...`}
                            value={keywordSearch}
                            onChange={(e) => setKeywordSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Store Type")} isShow={true}>
                          <DropdownAsyncBarType
                            name="type"
                            onChangeSelect={(event: any) => {
                              setOptionBarTypeSearch(event);
                              setTypeSearch(event?.value);
                            }}
                            isMulti={false}
                            placeholder={`${t("Select Type")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedBarType={optionBarTypeSearch}
                            isClearable={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Rating")} isShow={true}>
                          <DropdownOptionStar
                            name="rating"
                            dataList={
                              LIST_OPTION_BAR_DETAIL_REVIEW_STAR_RATING_LANG ||
                              []
                            }
                            placeholder={`${t("Rating")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={ratingSearch}
                            onChangeSelect={(e: any) =>
                              setRatingSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Plan")} isShow={true}>
                          <DropdownStatusNew
                            name="plan"
                            dataList={LIST_OPTION_BAR_LIST_PLAN || []}
                            placeholder={`${t("Select Plan")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={planSearch}
                            onChangeSelect={(e: any) => setPlanSearch(e?.value)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_BAR_LIST_PLAN}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Open Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={LIST_OPTION_BAR_LIST_OPEN_STATUS || []}
                            placeholder={`${t("Select Open Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_BAR_LIST_OPEN_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Partner Status")} isShow={true}>
                          <DropdownStatusNew
                            name="partner_status"
                            dataList={LIST_OPTION_BAR_LIST_PARTNER_STATUS || []}
                            placeholder={`${t("Select Partner Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={partnerStatusSearch}
                            onChangeSelect={(e: any) =>
                              setPartnerStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_BAR_LIST_PARTNER_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={6}
                        xl={6}
                        xxl={6}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-wink-media"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={bars?.list?.length ? bars?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={bars?.meta?.total}
                      customPageCount={Math.ceil(
                        Number(bars?.meta?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isBarLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {isOpen && (
          <BarForm
            setIsOpen={setIsOpen}
            id={itemToEdit?.id}
            setItemToEdit={setItemToEdit}
            loadTableData={loadTableData}
            triggerRefresh={triggerRefresh}
            setLinkImage={setLinkImage}
          />
        )}

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete Store Information")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        {itemToDetail && (
          <Modal
            isOpen={!!itemToDetail}
            centered={true}
            size="xl"
            className="modal-fullscreen"
            scrollable={false}
          >
            <ModalHeader toggle={handleCloseModal}>
              {itemToDetail?.title || ""}
            </ModalHeader>
            <ModalBody>
              <BarListDetail
                barID={itemToDetail?.id}
                setLinkImage={setLinkImage}
                tabDetailActive={tabDetailActive}
              />
            </ModalBody>
          </Modal>
        )}

        {previewQRCode && (
          <ModalPreviewQRCode
            data={previewQRCode}
            title={''}
            onCloseQRCodeClick={onCloseQRCodeClick}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default BarList;
